define("shared/components/shared/youtube-tos-modal", ["exports", "@ember/component", "@ember/template-factory", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "tracked-built-ins"], function (_exports, _component, _templateFactory, _object, _service, _component2, _tracking, _trackedBuiltIns) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"tracked-built-ins"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  {{#if this.shouldShowModal}}
    <Shared::Guidelines
      @agreeText={{t "credentials.youtube.tos_modal.accept"}}
      @checkboxList={{this.checkboxList}}
      @declineText={{t "shared_words.cancel"}}
      @onDeclinedAction={{this.rejectTerms}}
      @onSuccessAction={{this.acceptTerms}}
      @subtitle={{t "credentials.youtube.tos_modal.subtitle"}}
      @title={{t "credentials.youtube.tos_modal.title"}}
    />
  {{/if}}
  */
  {
    "id": "uHG6QoiP",
    "block": "[[[41,[30,0,[\"shouldShowModal\"]],[[[1,\"  \"],[8,[39,1],null,[[\"@agreeText\",\"@checkboxList\",\"@declineText\",\"@onDeclinedAction\",\"@onSuccessAction\",\"@subtitle\",\"@title\"],[[28,[37,2],[\"credentials.youtube.tos_modal.accept\"],null],[30,0,[\"checkboxList\"]],[28,[37,2],[\"shared_words.cancel\"],null],[30,0,[\"rejectTerms\"]],[30,0,[\"acceptTerms\"]],[28,[37,2],[\"credentials.youtube.tos_modal.subtitle\"],null],[28,[37,2],[\"credentials.youtube.tos_modal.title\"],null]]],null],[1,\"\\n\"]],[]],null]],[],false,[\"if\",\"shared/guidelines\",\"t\"]]",
    "moduleName": "shared/components/shared/youtube-tos-modal.hbs",
    "isStrictMode": false
  });

  let YoutubeToSModalComponent = (_class = class YoutubeToSModalComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "youtube", _descriptor, this);

      _initializerDefineProperty(this, "isChecked", _descriptor2, this);

      _defineProperty(this, "checkboxList", [new _trackedBuiltIns.TrackedObject({
        id: 'checkbox-1',
        label: 'credentials.youtube.tos_modal.accept_description',
        qaCheckbox: 'qa--youtube_tos_checkbox'
      })]);
    }

    get shouldShowModal() {
      return this.youtube.showYoutubeToSModal && !this.youtube.hasAcceptedTerms;
    }

    acceptTerms() {
      this.youtube.acceptTerms();
      this.youtube.showYoutubeToSModal = false;
    }

    rejectTerms() {
      this.youtube.rejectTerms();
      this.youtube.showYoutubeToSModal = false;
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "youtube", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "isChecked", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "acceptTerms", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "acceptTerms"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "rejectTerms", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "rejectTerms"), _class.prototype)), _class);
  _exports.default = YoutubeToSModalComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, YoutubeToSModalComponent);
});